import AccreditedListComposer from '../../../composers/AccreditedListComposer';

export default function AccreditedListPage(): JSX.Element {
  return <AccreditedListComposer />;
}
